module.exports = __webpack_public_path__ + "static/media/IMG-20230508-WA0177.3368010d.jpg";